export * from './IconPicture';
